import createLucideIcon from '../createLucideIcon';

const SignalLow = createLucideIcon('SignalLow', [
  ['path', { d: 'M2 20h.01', key: '4haj6o' }],
  ['path', { d: 'M7 20v-4', key: 'j294jx' }],
]);

export default SignalLow;
